import { type Writable, writable } from 'svelte/store';
import type { TeaserContent } from '../domain/teaser/TeaserContent.ts';
import type { TeaserType } from '../domain/teaser/TeaserType.ts';
import { TeaserTouchPoint } from '../domain/teaser/TeaserUtils.ts';

export const detailviewTeaserContextStore: Writable<Map<string, {
	teaserType: TeaserType,
	teaserContent?: TeaserContent,
	disableArticleTeaser: boolean,
	noContentReason?: string,
	teaserTouchPoint: TeaserTouchPoint
}>> = writable(new Map<string, { teaserType: TeaserType,
	teaserContent?: TeaserContent,
	disableArticleTeaser: boolean,
	noContentReason?: string,
	teaserTouchPoint: TeaserTouchPoint }>([]));

export const addElementToDetailviewContextStore =
	(url: string,
		context: {
			teaserType: TeaserType,
			teaserContent?: TeaserContent,
			disableArticleTeaser: boolean,
			noContentReason?: string,
			teaserTouchPoint: TeaserTouchPoint
		}) => {
		detailviewTeaserContextStore.update((contextStore) => {
		contextStore.set(url, context);
		return contextStore;
	});
};